import { IconProps } from ".";

export const VirtualMachineIcon: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
      <rect
        x="2"
        y="3"
        width="20"
        height="6"
        rx="3"
        stroke="#737373"
        style={{ stroke: "#737373", strokeOpacity: "1" }}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 15H5C3.34315 15 2 13.6569 2 12V12C2 10.3431 3.34315 9 5 9H19C20.6569 9 22 10.3431 22 12V12"
        stroke="#737373"
        style={{ stroke: "#737373", strokeOpacity: "1" }}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 15H5C3.34315 15 2 16.3431 2 18V18C2 19.6569 3.34315 21 5 21H7"
        stroke="#737373"
        style={{ stroke: "#737373", strokeOpacity: "1" }}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 18H6.00177"
        stroke="#737373"
        style={{ stroke: "#737373", strokeOpacity: "1" }}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 12H6.00177"
        stroke="#737373"
        style={{ stroke: "#737373", strokeOpacity: "1" }}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 6H6.00177"
        stroke="#737373"
        style={{ stroke: "#737373", strokeOpacity: "1" }}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 15C18.6569 15 20 16.3431 20 18H20.5C21.8807 18 23 19.1193 23 20.5C23 21.8807 21.8807 23 20.5 23H13.5C12.1193 23 11 21.8807 11 20.5C11 19.1193 12.1193 18 13.5 18H14C14 16.3431 15.3431 15 17 15Z"
        stroke="#737373"
        style={{ stroke: "#737373", strokeOpacity: "1" }}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 6L18 6"
        stroke="#737373"
        style={{ stroke: "#737373", strokeOpacity: "1" }}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 12L18 12"
        stroke="#737373"
        style={{ stroke: "#737373", strokeOpacity: "1" }}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
